export const EMAIL_ALREADY_SENT = 'Email has already been sent. Please use the code already sent or generate a new one.';
export const PLEASE_WAIT = 'Please wait a few minutes before retrying.';
